<template>
    <div :class="cardCvcInputClass">
        <label class="input__label"
            :class="{ 'required-input': mandatory }"
            v-if="showLabel"
            v-text="$t('STRIPE_ELEMENTS_SECURITY_NUMBER')"/>
        <div ref="input" :id="`${_uid}-input`"/>
    </div>
</template>

<script>
import { stripeElementsClasses, stripeElementsStyle } from '@/config/StripeElements';

export default {
    name: 'StripeCardCvcInput',
    data: () => {
        return {
            cardCvc: null,
        };
    },
    props: {
        stripeElements: {
            required: true,
        },
        hasBeenRequested: {
            required: true,
            default: false,
        },
        noPadding: {
            default: false,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
        showLabel: {
            default: true,
            type: Boolean,
        },
    },
    mounted: function() {
        this.mountCardCvcField();
    },
    destroy: function() {
        this.cardCvc.unmount();
        this.cardCvc.destroy();
    },
    methods: {
        /**
         * Handle mounting the card cvc field.
         *
         * @returns {void}
         */
        mountCardCvcField() {
            this.cardCvc = this.stripeElements.create('cardCvc', {
                classes: stripeElementsClasses,
                style: stripeElementsStyle,
                placeholder: '–––',
            });

            this.cardCvc.mount(this.$refs.input);
        },
    },
    computed: {
        isValid() {
            return this.cardCvcValid;
        },
        cardCvcInputClass() {
            return !(this.cardCvcEmpty && this.hasBeenRequested) && this.cardCvcValid && !this.errorMessage
                ? `input ${this.noPadding ? 'noPadding' : ''}`
                : `input input--invalid ${this.noPadding ? 'noPadding' : ''}`;
        },
        cardCvcEmpty() {
            return this.cardCvc?._implementation?._empty;
        },
        cardCvcValid() {
            return this.cardCvc && !(this.cardCvc._implementation?._invalid && !this.cardCvc._implementation._empty);
        },
        errorMessage() {
            if (!this.hasBeenRequested) {
                return null;
            }

            if (this.cardCvcEmpty) {
                return this.$t('STRIPE_ELEMENTS_SECURITY_CODE');
            }

            if (!this.cardCvcValid) {
                return this.$t('STRIPE_ELEMENTS_TAKE_ANOTHER_LOOK');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.noPadding {
    padding: 0;
}
</style>
